import React, {useState} from "react";
import img404 from "../static/img/404/404fxbitcoin.jpg";
import "./404.css";
import Cookies from "universal-cookie";
import LayoutMain from "./00LayoutMain/LayoutMain";
import ChangeLink from "../Elements/ChangeLink/ChangeLink";
import TextChange from "../../AdminPart/src/Elements/TextChange/TextChange";
const cookies = new Cookies();

// Логика страницы 404 - если нет внутри кукиса языка показываем английский. а если есть - то русский.

let lang = cookies.get('lang') || 'en';

    function HTML404 (props) {
            function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
            } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}
        const [valueFindForm, setValueFindForm] = useState('');

        function ChangeElement (event) {setValueFindForm(event.target.value);}

                return (
        <LayoutMain title={props.title} description={props.description} lang={lang}>
            <div className="HTML404 StandartPage">
                <main className="html404 StandartPage">
                    <div className="html404TopIMG"><img alt='Ifyoudontseeimages' src={img404}/></div>
                    <div className="html404Element ">
                        <div className="html404TopText StandartIn">
                            <script async src="https://cse.google.com/cse.js?cx=013551508466589692602:up3e1inw0-c"/>
                            <div className="gcse-search"/>
                            <div className="html404TopText01"><TextSource ArrIndex= 'Page4040010'>Не нашли, что искали? Воспользуйтесь поиском:</TextSource></div>
                            <div className="html404TopTextInput">
                            <input className="FindForm" type="text"  value={valueFindForm ? valueFindForm : ''} name="valueFindForm" onChange={ChangeElement} placeholder={JSON.parse(props.PrerenderTexts['Page4040015'])[props.lang] ? JSON.parse(props.PrerenderTexts['Page4040015'])[props.lang] : '*Поиск'}/>
                                <div  className="ButtonRed"><TextSource ArrIndex= 'Page4040020'>Найти</TextSource></div>
                            </div>
                        </div>
                        <div className="html404TopText StandartIn">
                            <div className="html404TopText02"><TextSource ArrIndex= 'Page4040025'>Полезные ссылки:</TextSource></div>
                            <div className="html404FlexButtons">
                                <ChangeLink to={"/trader/open/"} lang = {props.lang}  style={{textDecoration: 'none'}}>
                                    <div className={'Button404'} >
                                        <nobr className="StandartNoPhone"><TextSource ArrIndex= 'IndexMain0030'>Открыть торговый счет</TextSource></nobr>
                                        <nobr  className="StandartPhone"><TextSource ArrIndex= 'IndexMain0035'>Открыть счет</TextSource></nobr>
                                    </div>
                                </ChangeLink>
                            </div>
                        </div>
                    </div>
                </main>
                <div className="html404Map StandartIn">
                <div className="StandartTitle"><TextSource ArrIndex= 'Page4040040'>Карта сайта</TextSource></div>
                <div className="StandartText"><TextSource ArrIndex= 'Page4040045'>Ошибка 404: внимание, к сожалению такая страница не найдена  - если это ошибка пожалуйста напишите нам как вы на нее попали по мейлу - а вообще вот все наши страницы:</TextSource></div>
                    </div>
            </div>
        </LayoutMain>
    )}


export default HTML404